/* eslint-disable no-shadow */
import gql from 'graphql-tag'
import api from '../apiClient'
import { runSubscription } from '../subscriptor/index'
import {
  general,
  emisor,
  receptor,
  condiciones,
  detalleServicio,
  impuesto,
  otrosCargos,
  resumenFactura,
  informacionReferencia,
  otros,
  user
} from './factura.fraqments'

export default {
  readByEmisor: (emisor, cursor, limit = 10, documento = null, filter = null) =>
    api
      .send({
        query: gql`
          query readByEmisor($emisor: ID!, $cursor: String, $limit: Int, $documento: String, $filter: Filter) {
            Factura {
              readByEmisor(emisor: $emisor, cursor: $cursor, limit: $limit, documento: $documento, filter: $filter) {
                feed {
                  id
                  documento {
                    id
                    value
                  }
                  consecutivo
                  createdAt
                  fechaEmisionOriginal
                  original
                  next
                  mail
                  emisor {
                    nombre
                    identificacion {
                      numero
                    }
                  }
                  receptor {
                    nombre
                    identificacion {
                      numero
                    }
                    identificacionExtranjero
                  }
                  resumenFactura {
                    codigoTipoMoneda {
                      codigoMoneda {
                        id
                        value
                        simbolo
                      }
                      tipoCambio
                    }
                    totalVentaNeta
                    totalImpuesto
                    totalComprobante
                  }
                  estadoDocumento {
                    value
                    annotation
                  }
                  notaCredito {
                    id
                  }
                  mensaje {
                    id
                    annotation
                  }
                }
                pageInfo {
                  nextPageCursor
                  hasNextPage
                }
              }
            }
          }
        `,
        variables: {
          emisor,
          cursor,
          limit,
          filter,
          documento
        }
      })
      .then(result => result.data.data.Factura.readByEmisor),

  readDocumentosBySearchString: (emisor, searchString, documento) =>
    api
      .send({
        query: gql`
          query readDocumentosBySearchString($emisor: ID!, $searchString: String!, $documento: String!) {
            Factura {
              readDocumentosBySearchString(emisor: $emisor, searchString: $searchString, documento: $documento) {
                feed {
                  id
                  documento {
                    id
                    value
                  }
                  consecutivo
                  createdAt
                  fechaEmisionOriginal
                  original
                  next
                  mail
                  emisor {
                    nombre
                    identificacion {
                      numero
                    }
                  }
                  receptor {
                    nombre
                    identificacion {
                      numero
                    }
                    identificacionExtranjero
                  }
                  resumenFactura {
                    codigoTipoMoneda {
                      codigoMoneda {
                        id
                        value
                        simbolo
                      }
                      tipoCambio
                    }
                    totalVentaNeta
                    totalImpuesto
                    totalComprobante
                  }
                  estadoDocumento {
                    value
                    annotation
                  }
                  notaCredito {
                    id
                  }
                  mensaje {
                    id
                    annotation
                  }
                }
              }
            }
          }
        `,
        variables: {
          emisor,
          searchString,
          documento
        }
      })
      .then(result => result.data.data.Factura.readDocumentosBySearchString),

  readDocumentosCredito: (emisor, cursor, limit = 10, filter = null, isFEC = false, showContado = false) =>
    api
      .send({
        query: gql`
          query readDocumentosCredito($emisor: ID!, $cursor: String, $limit: Int, $filter: Filter, $isFEC: Boolean, $showContado: Boolean) {
            Factura {
              readDocumentosCredito(emisor: $emisor, cursor: $cursor, limit: $limit, filter: $filter, isFEC: $isFEC, showContado: $showContado) {
                feed {
                  id
                  documento {
                    id
                    value
                  }
                  consecutivo
                  fechaEmisionOriginal
                  original
                  plazoCredito

                  createdAt
                  mail
                  waSent
                  waNotifica
                  emisor {
                    nombre
                    identificacion {
                      numero
                    }
                  }
                  receptor {
                    nombre
                    identificacion {
                      numero
                    }
                    identificacionExtranjero
                  }
                  resumenFactura {
                    codigoTipoMoneda {
                      codigoMoneda {
                        id
                        value
                        simbolo
                      }
                      tipoCambio
                    }
                    totalVentaNeta
                    totalImpuesto
                    totalComprobante
                  }
                  saldo
                  estadoDocumento {
                    value
                    annotation
                  }
                  notaCredito {
                    id
                  }
                  mensaje {
                    id
                    annotation
                  }

                  registroContable
                }
                pageInfo {
                  nextPageCursor
                  hasNextPage
                }
              }
            }
          }
        `,
        variables: {
          emisor,
          cursor,
          limit,
          filter,
          isFEC,
          showContado
        }
      })
      .then(result => result.data.data.Factura.readDocumentosCredito),

  readCreditoBySearchString: (emisor, searchString, isFEC = false, showContado = false) =>
    api
      .send({
        query: gql`
          query readCreditoBySearchString($emisor: ID!, $searchString: String!, $isFEC: Boolean, $showContado: Boolean) {
            Factura {
              readCreditoBySearchString(emisor: $emisor, searchString: $searchString, isFEC: $isFEC, showContado: $showContado) {
                feed {
                  id
                  documento {
                    id
                    value
                  }
                  consecutivo
                  fechaEmisionOriginal
                  original
                  plazoCredito

                  createdAt
                  mail
                  waSent
                  waNotifica
                  emisor {
                    nombre
                    identificacion {
                      numero
                    }
                  }
                  receptor {
                    nombre
                    identificacion {
                      numero
                    }
                    identificacionExtranjero
                  }
                  resumenFactura {
                    codigoTipoMoneda {
                      codigoMoneda {
                        id
                        value
                        simbolo
                      }
                      tipoCambio
                    }
                    totalVentaNeta
                    totalImpuesto
                    totalComprobante
                  }
                  saldo
                  estadoDocumento {
                    value
                    annotation
                  }
                  notaCredito {
                    id
                  }
                  mensaje {
                    id
                    annotation
                  }

                  registroContable
                }
              }
            }
          }
        `,
        variables: {
          emisor,
          searchString,
          isFEC,
          showContado
        }
      })
      .then(result => result.data.data.Factura.readCreditoBySearchString),

  readDocumentosProforma: (emisor, cursor, limit = 10, filter = null) =>
    api
      .send({
        query: gql`
          query readDocumentosProforma($emisor: ID!, $cursor: String, $limit: Int, $filter: Filter) {
            Factura {
              readDocumentosProforma(emisor: $emisor, cursor: $cursor, limit: $limit, filter: $filter) {
                feed {
                  id
                  documento {
                    id
                    value
                  }
                  consecutivo

                  plazoProforma
                  estadoProforma

                  createdAt
                  mail
                  emisor {
                    nombre
                    identificacion {
                      numero
                    }
                  }
                  receptor {
                    nombre
                    identificacion {
                      numero
                    }
                    identificacionExtranjero
                  }
                  resumenFactura {
                    codigoTipoMoneda {
                      codigoMoneda {
                        id
                        value
                        simbolo
                      }
                      tipoCambio
                    }

                    totalVentaNeta
                    totalImpuesto
                    totalComprobante
                  }

                  estadoDocumento {
                    value
                    annotation
                  }

                  mensaje {
                    id
                    annotation
                  }
                }
                pageInfo {
                  nextPageCursor
                  hasNextPage
                }
              }
            }
          }
        `,
        variables: {
          emisor,
          cursor,
          limit,
          filter
        }
      })
      .then(result => result.data.data.Factura.readDocumentosProforma),

  readProformaBySearchString: (emisor, searchString) =>
    api
      .send({
        query: gql`
          query readProformaBySearchString($emisor: ID!, $searchString: String!) {
            Factura {
              readProformaBySearchString(emisor: $emisor, searchString: $searchString) {
                feed {
                  id
                  documento {
                    id
                    value
                  }
                  consecutivo

                  plazoProforma
                  estadoProforma

                  createdAt
                  mail
                  emisor {
                    nombre
                    identificacion {
                      numero
                    }
                  }
                  receptor {
                    nombre
                    identificacion {
                      numero
                    }
                    identificacionExtranjero
                  }
                  resumenFactura {
                    codigoTipoMoneda {
                      codigoMoneda {
                        id
                        value
                        simbolo
                      }
                      tipoCambio
                    }

                    totalVentaNeta
                    totalImpuesto
                    totalComprobante
                  }

                  estadoDocumento {
                    value
                    annotation
                  }

                  mensaje {
                    id
                    annotation
                  }
                }
              }
            }
          }
        `,
        variables: {
          emisor,
          searchString
        }
      })
      .then(result => result.data.data.Factura.readProformaBySearchString),

  readById: (id, showItemRelated = false) =>
    api
      .send({
        query: gql`
          query readById($id: ID!, $showItemRelated: Boolean) {
            Factura {
              readById(id: $id, showItemRelated: $showItemRelated) {
                id
                ...user
                ...emisor
                ...receptor
                ...general
                ...condiciones
                ...detalleServicio
                ...otrosCargos
                ...resumenFactura
                ...informacionReferencia
                ...otros

                codigoActividadEmisor
                codigoActividadReceptor

                notaCredito {
                  id
                }

                posOrder {
                  _id
                  consecutive
                }

                plazoCredito
                cajaSesion {
                  _id
                  caja {
                    _id
                    name
                  }
                }
              }
            }
          }

          ${user.fragment}
          ${general.fragment}
          ${condiciones.fragment}
          ${emisor.fragment}
          ${receptor.fragment}
          ${condiciones.fragment}
          ${detalleServicio.fragment}
          ${impuesto.fragment}
          ${otrosCargos.fragment}
          ${resumenFactura.fragment}
          ${informacionReferencia.fragment}
          ${otros.fragment}
        `,
        variables: {
          id,
          showItemRelated
        }
      })
      .then(result => result.data.data.Factura.readById),

  readBulkById: id =>
    api
      .send({
        query: gql`
          query readBulkById($id: ID!) {
            Factura {
              readBulkById(id: $id) {
                id
                ...user
                ...detalleServicio
                ...otrosCargos
                ...resumenFactura

                consecutivo
                state
                createdAt

                documento {
                  id
                  value
                }
                notaCredito {
                  id
                }
                plazoCredito
                cajaSesion {
                  _id
                  caja {
                    _id
                    name
                  }
                }
              }
            }
          }

          ${user.fragment}
          ${detalleServicio.fragment}
          ${impuesto.fragment}
          ${otrosCargos.fragment}
          ${resumenFactura.fragment}
        `,
        variables: {
          id
        }
      })
      .then(result => result.data.data.Factura.readBulkById),

  /*
  readPagosByIdFactura: (_id, cursor, limit = 10) =>
    api
      .send({
        query: gql`
          query readPagosByIdFactura($_id: ID!, $cursor: String, $limit: Int) {
            Factura {
              readPagosByIdFactura(_id: $_id, cursor: $cursor, limit: $limit) {
                feed {
                  _id
                  fecha
                  consecutivo
                  monto
                  estado
                  concepto
                  usuario

                  createdAt
                  updatedAt
                }
                pageInfo {
                  nextPageCursor
                  hasNextPage
                }
              }
            }
          }
        `,
        variables: {
          _id,
          cursor,
          limit
        }
      })
      .then(result => result.data.data.Factura.readPagosByIdFactura),
      */

  readByDateRange: (emisor, inicio, final, documento = null) =>
    api
      .send({
        query: gql`
          query readByDateRange($emisor: ID!, $inicio: Date, $final: Date, $documento: String) {
            Factura {
              readByDateRange(emisor: $emisor, inicio: $inicio, final: $final, documento: $documento) {
                feed {
                  id
                  documento {
                    id
                    value
                  }
                  consecutivo
                  createdAt
                  next
                  mail
                  emisor {
                    nombre
                    identificacion {
                      numero
                    }
                  }
                  receptor {
                    nombre
                    identificacion {
                      numero
                    }
                    identificacionExtranjero
                  }
                  resumenFactura {
                    codigoTipoMoneda {
                      codigoMoneda {
                        id
                        value
                        simbolo
                      }
                      tipoCambio
                    }
                    totalVentaNeta
                    totalImpuesto
                    totalComprobante
                  }
                  estadoDocumento {
                    value
                    annotation
                  }
                  notaCredito {
                    id
                  }
                  mensaje {
                    id
                    annotation
                  }
                }
                pageInfo {
                  nextPageCursor
                  hasNextPage
                }
              }
            }
          }
        `,
        variables: {
          emisor,
          inicio,
          final,
          documento
        }
      })
      .then(result => result.data.data.Factura.readByDateRange),

  readBulkByDateRange: (emisor, inicio, final, documento = null) =>
    api
      .send({
        query: gql`
          query readBulkByDateRange($emisor: ID!, $inicio: Date, $final: Date) {
            Factura {
              readBulkByDateRange(emisor: $emisor, inicio: $inicio, final: $final) {
                feed {
                  id
                  consecutivo
                  state
                  createdAt
                  resumenFactura {
                    codigoTipoMoneda {
                      codigoMoneda {
                        id
                        value
                        simbolo
                      }
                      tipoCambio
                    }
                    totalVentaNeta
                    totalImpuesto
                    totalComprobante
                  }
                  notaCredito {
                    id
                  }
                }
              }
            }
          }
        `,
        variables: {
          emisor,
          inicio,
          final
        }
      })
      .then(result => result.data.data.Factura.readBulkByDateRange),

  readCreditoByDateRange: (emisor, inicio, final, isFEC = false, showContado = false) =>
    api
      .send({
        query: gql`
          query readCreditoByDateRange($emisor: ID!, $inicio: Date, $final: Date, $isFEC: Boolean, $showContado: Boolean) {
            Factura {
              readCreditoByDateRange(emisor: $emisor, inicio: $inicio, final: $final, isFEC: $isFEC, showContado: $showContado) {
                feed {
                  id
                  documento {
                    id
                    value
                  }
                  consecutivo
                  fechaEmisionOriginal
                  original
                  plazoCredito

                  createdAt
                  mail
                  waSent
                  waNotifica
                  
                  emisor {
                    nombre
                    identificacion {
                      numero
                    }
                  }
                  receptor {
                    nombre
                    identificacion {
                      numero
                    }
                    identificacionExtranjero
                  }
                  resumenFactura {
                    codigoTipoMoneda {
                      codigoMoneda {
                        id
                        value
                        simbolo
                      }
                      tipoCambio
                    }
                    totalVentaNeta
                    totalImpuesto
                    totalComprobante
                  }
                  saldo
                  estadoDocumento {
                    value
                    annotation
                  }
                  notaCredito {
                    id
                  }
                  mensaje {
                    id
                    annotation
                  }

                  registroContable
                }
                pageInfo {
                  nextPageCursor
                  hasNextPage
                }
              }
            }
          }
        `,
        variables: {
          emisor,
          inicio,
          final,
          isFEC,
          showContado
        }
      })
      .then(result => result.data.data.Factura.readCreditoByDateRange),

  readProformaByDateRange: (emisor, inicio, final) =>
    api
      .send({
        query: gql`
          query readProformaByDateRange($emisor: ID!, $inicio: Date, $final: Date) {
            Factura {
              readProformaByDateRange(emisor: $emisor, inicio: $inicio, final: $final) {
                feed {
                  id
                  documento {
                    id
                    value
                  }
                  consecutivo

                  plazoProforma
                  estadoProforma

                  createdAt
                  mail
                  emisor {
                    nombre
                    identificacion {
                      numero
                    }
                  }
                  receptor {
                    nombre
                    identificacion {
                      numero
                    }
                    identificacionExtranjero
                  }
                  resumenFactura {
                    codigoTipoMoneda {
                      codigoMoneda {
                        id
                        value
                        simbolo
                      }
                      tipoCambio
                    }
                    totalVentaNeta
                    totalImpuesto
                    totalComprobante
                  }

                  estadoDocumento {
                    value
                    annotation
                  }

                  mensaje {
                    id
                    annotation
                  }
                }
                pageInfo {
                  nextPageCursor
                  hasNextPage
                }
              }
            }
          }
        `,
        variables: {
          emisor,
          inicio,
          final
        }
      })
      .then(result => result.data.data.Factura.readProformaByDateRange),

  readByFilter: (emisor, limit = 10, cursor, filter, documento = null) =>
    api
      .send({
        query: gql`
          query readByFilter($emisor: ID!, $limit: Int, $cursor: String, $filter: Filter!, $documento: String) {
            Factura {
              readByFilter(emisor: $emisor, limit: $limit, cursor: $cursor, filter: $filter, documento: $documento) {
                feed {
                  id
                  consecutivo
                  createdAt
                  emisor {
                    nombre
                    identificacion {
                      numero
                    }
                  }
                  receptor {
                    nombre
                    identificacion {
                      numero
                    }
                  }
                  resumenFactura {
                    codigoTipoMoneda {
                      codigoMoneda {
                        id
                        value
                        simbolo
                      }
                      tipoCambio
                    }
                    totalImpuesto
                    totalComprobante
                  }
                  estadoDocumento {
                    value
                    annotation
                  }
                  mensaje {
                    id
                    annotation
                  }
                }
                pageInfo {
                  nextPageCursor
                  hasNextPage
                }
              }
            }
          }
        `,
        variables: {
          emisor,
          limit,
          cursor,
          filter,
          documento
        }
      })
      .then(result => result.data.data.Factura.readByFilter),

  subscriptionNewFactura: (emisor, fn) =>
    runSubscription(
      {
        query: gql`
          subscription facturaChanged($emisor: ID!) {
            facturaChanged(emisor: $emisor) {
              id
              mail
              documento {
                id
                value
              }
              consecutivo
              condicionVenta {
                id
                annotation
              }
              createdAt
              plazoCredito
              emisor {
                nombre
                identificacion {
                  numero
                }
              }
              receptor {
                nombre
                identificacion {
                  numero
                }
              }
              resumenFactura {
                codigoTipoMoneda {
                  codigoMoneda {
                    id
                    simbolo
                  }
                  tipoCambio
                }
                totalImpuesto
                totalComprobante
              }
              estadoDocumento {
                value
                annotation
              }
              mensaje {
                id
                annotation
              }
            }
          }
        `,
        variables: {
          emisor
        }
      },
      (err, result) => {
        if (!err) fn(result.data.facturaChanged)
      }
    ),

  create: (item, inventario, creaClave = false, productionOrder = false, cuentaContablePago = null, bulkMode = false, accounting = false, autoPago = true) =>
    api
      .send({
        query: gql`
          mutation create(
            $item: FacturaInput!
            $inventario: Boolean
            $creaClave: Boolean
            $productionOrder: Boolean
            $cuentaContablePago: ID
            $bulkMode: Boolean
            $accounting: Boolean
            $autoPago: Boolean
          ) {
            Factura {
              create(
                input: $item
                inventario: $inventario
                creaClave: $creaClave
                productionOrder: $productionOrder
                cuentaContablePago: $cuentaContablePago
                bulkMode: $bulkMode
                accounting: $accounting
                autoPago: $autoPago
              ) {
                id
                consecutivo
              }
            }
          }
        `,
        variables: {
          item,
          inventario,
          creaClave,
          productionOrder,
          cuentaContablePago,
          bulkMode,
          accounting,
          autoPago
        }
      })
      .then(result => result.data.data.Factura.create),

  // TODO: inventario rollback
  createNotaCredito: (factura, item, inventario, creaClave = false, accounting) =>
    api
      .send({
        query: gql`
          mutation createNotaCredito($factura: ID!, $item: FacturaInput!, $inventario: Boolean, $creaClave: Boolean, $accounting: Boolean) {
            Factura {
              createNotaCredito(factura: $factura, input: $item, inventario: $inventario, creaClave: $creaClave, accounting: $accounting) {
                id
                consecutivo
              }
            }
          }
        `,
        variables: {
          factura,
          item,
          inventario,
          creaClave,
          accounting
        }
      })
      .then(result => result.data.data.Factura.createNotaCredito),

  createAnulaCompra: (factura, item, inventario, accounting) =>
    api
      .send({
        query: gql`
          mutation createAnulaCompra($factura: ID!, $item: FacturaInput!, $inventario: Boolean, $accounting: Boolean) {
            Factura {
              createAnulaCompra(factura: $factura, input: $item, inventario: $inventario, accounting: $accounting) {
                id
                consecutivo
              }
            }
          }
        `,
        variables: {
          factura,
          item,
          inventario,
          accounting
        }
      })
      .then(result => result.data.data.Factura.createAnulaCompra),

  cambiaEstadoProforma: (_id, estado) =>
    api
      .send({
        query: gql`
          mutation cambiaEstadoProforma($_id: ID!, $estado: String!) {
            Factura {
              cambiaEstadoProforma(_id: $_id, estado: $estado)
            }
          }
        `,
        variables: {
          _id,
          estado
        }
      })
      .then(result => result.data.data.Factura.cambiaEstadoProforma),

  createMensajeReceptor: (item, force, inventario, creaClave = false, cuentaContablePago, accounting) =>
    api
      .send({
        query: gql`
          mutation createMensajeReceptor(
            $item: MensajeReceptorInput!
            $force: Boolean
            $inventario: Boolean
            $creaClave: Boolean
            $cuentaContablePago: ID
            $accounting: Boolean
          ) {
            Factura {
              createMensajeReceptor(
                input: $item
                force: $force
                inventario: $inventario
                creaClave: $creaClave
                cuentaContablePago: $cuentaContablePago
                accounting: $accounting
              ) {
                claveFE
                returnState
                consecutivo
              }
            }
          }
        `,
        variables: {
          item,
          force,
          inventario,
          creaClave,
          cuentaContablePago,
          accounting
        }
      })
      .then(result => result.data.data.Factura.createMensajeReceptor),

  setFirst: item =>
    api
      .send({
        query: gql`
          mutation counter($item: firstDocInput) {
            Factura {
              setFirst(input: $item)
            }
          }
        `,
        variables: {
          item
        }
      })
      .then(result => result.data.data.Factura.setFirst),

  getCounters: emisor =>
    api
      .send({
        query: gql`
          query counter($emisor: ID!) {
            Factura {
              getCounters(emisor: $emisor) {
                value
                type
              }
            }
          }
        `,
        variables: {
          emisor
        }
      })
      .then(result => result.data.data.Factura.getCounters),

  readTipoCambioBCCR: () =>
    api
      .send({
        query: gql`
          query readTipoCambioBCCR {
            TYPES {
              TipoCambio {
                read {
                  compra
                  venta
                  fecha
                }
              }
            }
          }
        `
      })
      .then(result => result.data.data.TYPES.TipoCambio.read),

  generarReporte: (emisor, filter, showNC, showRechazadas) =>
    api
      .send({
        query: gql`
          query generarReporte($emisor: ID!, $filter: FilterVentas!, $showNC: Boolean, $showRechazadas: Boolean) {
            Factura {
              generarReporte(emisor: $emisor, filter: $filter, showNC: $showNC, showRechazadas: $showRechazadas) {
                ventas {
                  _id
                  createdAt
                  notaCredito {
                    id
                  }
                  receptor {
                    id
                    nombre
                  }
                  documento {
                    annotation
                    value
                  }
                  estadoDocumento {
                    value
                  }
                  consecutivo
                  ...condiciones

                  resumenFactura {
                    codigoTipoMoneda {
                      codigoMoneda {
                        simbolo
                      }
                      tipoCambio
                    }
                    medioPago {
                      annotation
                    }
                    totalVentaNeta
                    totalImpuesto
                    totalOtrosCargos
                    totalComprobante
                  }
                }
                notaCredito {
                  _id
                  createdAt
                  consecutivo
                  documento {
                    annotation
                    value
                  }
                  informacionReferencia {
                    razon
                  }
                  estadoDocumento {
                    value
                  }
                  resumenFactura {
                    codigoTipoMoneda {
                      codigoMoneda {
                        simbolo
                      }
                      tipoCambio
                    }
                    totalVentaNeta
                    totalImpuesto
                    totalOtrosCargos
                    totalComprobante
                  }
                }
              }
            }
          }

          ${condiciones.fragment}
        `,
        variables: {
          emisor,
          filter,
          showNC,
          showRechazadas
        }
      })
      .then(result => result.data.data.Factura.generarReporte),

  generarReporteCompras: (receptor, filter, showNC, showRechazadas) =>
    api
      .send({
        query: gql`
          query generarReporteCompras($receptor: ID!, $filter: FilterVentas!, $showNC: Boolean, $showRechazadas: Boolean) {
            Factura {
              generarReporteCompras(receptor: $receptor, filter: $filter, showNC: $showNC, showRechazadas: $showRechazadas) {
                compras {
                  _id
                  createdAt
                  notaCredito {
                    id
                  }
                  emisor {
                    nombre
                  }
                  documento {
                    annotation
                  }
                  consecutivo
                  fechaEmisionOriginal
                  original
                  ...condiciones

                  resumenFactura {
                    codigoTipoMoneda {
                      codigoMoneda {
                        simbolo
                      }
                      tipoCambio
                    }
                    totalVentaNeta
                    totalImpuesto
                    totalComprobante
                  }
                }
                notaCredito {
                  _id
                  createdAt
                  consecutivo
                  documento {
                    annotation
                  }
                  informacionReferencia {
                    razon
                  }
                  resumenFactura {
                    codigoTipoMoneda {
                      codigoMoneda {
                        simbolo
                      }
                      tipoCambio
                    }
                    totalVentaNeta
                    totalImpuesto
                    totalComprobante
                  }
                }
              }
            }
          }

          ${condiciones.fragment}
        `,
        variables: {
          receptor,
          filter,
          showNC,
          showRechazadas
        }
      })
      .then(result => result.data.data.Factura.generarReporteCompras),

  ventasCliente: (emisor, _id, showNC) =>
    api
      .send({
        query: gql`
          query ventasCliente($emisor: ID!, $_id: ID!, $showNC: Boolean) {
            Factura {
              ventasCliente(emisor: $emisor, _id: $_id, showNC: $showNC) {
                facturas {
                  _id
                  consecutivo
                  createdAt
                  notaCredito {
                    id
                  }
                  resumenFactura {
                    codigoTipoMoneda {
                      codigoMoneda {
                        simbolo
                      }
                      # tipoCambio
                    }
                    totalVenta
                    totalDescuentos
                    totalImpuesto
                    totalComprobante
                  }
                }
                itemGroup {
                  _id {
                    itemId
                    simbolo
                  }
                  nombre
                  cantidad
                  total
                }
              }
            }
          }
        `,
        variables: {
          emisor,
          _id,
          showNC
        }
      })
      .then(result => result.data.data.Factura.ventasCliente),

  crearEstadisticas: (emisor, filter) =>
    api
      .send({
        query: gql`
          query crearEstadisticas($emisor: ID!, $filter: FilterVentas!) {
            Factura {
              crearEstadisticas(emisor: $emisor, filter: $filter) {
                item {
                  _id
                  nombre
                  montoTotalLinea
                  cantidad
                }
                receptor {
                  id
                  nombre
                }
                # user
                # resumenFactura {
                #   totalVentaNeta
                # }
                createdAt
              }
            }
          }
        `,
        variables: {
          emisor,
          filter
        }
      })
      .then(result => result.data.data.Factura.crearEstadisticas),

  reSendEmail: ({ id, email }) =>
    api
      .send({
        query: gql`
          mutation reSendEmail($id: ID!, $email: String!) {
            Factura {
              reSendEmail(id: $id, email: $email)
            }
          }
        `,
        variables: {
          id,
          email
        }
      })
      .then(result => result.data.data.Factura.reSendEmail),

  facturacionCounter: emisor =>
    api
      .send({
        query: gql`
          query facturacionCounter($emisor: ID!) {
            Factura {
              facturacionCounter(emisor: $emisor) {
                counter
                profile
              }
            }
          }
        `,
        variables: {
          emisor
        }
      })
      .then(result => result.data.data.Factura.facturacionCounter),

  readTotalDocumentos: (emisor, documento) =>
    api
      .send({
        query: gql`
          query readTotalDocumentos($emisor: ID!, $documento: String!) {
            Factura {
              readTotalDocumentos(emisor: $emisor, documento: $documento)
            }
          }
        `,
        variables: {
          emisor,
          documento
        }
      })
      .then(result => result.data.data.Factura.readTotalDocumentos),

  readTotalDocumentosCobrar: (emisor, showContado) =>
    api
      .send({
        query: gql`
          query readTotalDocumentosCobrar($emisor: ID!, $showContado: Boolean!) {
            Factura {
              readTotalDocumentosCobrar(emisor: $emisor, showContado: $showContado)
            }
          }
        `,
        variables: {
          emisor,
          showContado
        }
      })
      .then(result => result.data.data.Factura.readTotalDocumentosCobrar),

  readTotalDocumentosPagar: (emisor, showContado) =>
    api
      .send({
        query: gql`
          query readTotalDocumentosPagar($emisor: ID!, $showContado: Boolean!) {
            Factura {
              readTotalDocumentosPagar(emisor: $emisor, showContado: $showContado)
            }
          }
        `,
        variables: {
          emisor,
          showContado
        }
      })
      .then(result => result.data.data.Factura.readTotalDocumentosPagar),

  sendMailEstadoCuenta: (emisor, logo, receptor) =>
    api
      .send({
        query: gql`
          mutation sendMailEstadoCuenta($emisor: String!, $logo: String, $receptor: ReceptorInput!) {
            Factura {
              sendMailEstadoCuenta(emisor: $emisor, logo: $logo, receptor: $receptor)
            }
          }
        `,
        variables: {
          emisor,
          receptor,
          logo
        }
      })
      .then(result => result.data.data.Factura.sendMailEstadoCuenta),

  // TODO: REVISAR ESTO
  createTransaction: (item, bankAccount) =>
    api
      .send({
        query: gql`
          mutation createTransaction($item: FacturaInput!, $bankAccount: AccountInput!) {
            Factura {
              createTransaction(input: $item, bankAccount: $bankAccount)
            }
          }
        `,
        variables: {
          item,
          bankAccount
        }
      })
      .then(result => result.data.data.Factura.createTransaction),

  createNotaCreditoBulk: (_id, razon) =>
    api
      .send({
        query: gql`
          mutation createNotaCreditoBulk($_id: ID!, $razon: String!) {
            Factura {
              createNotaCreditoBulk(_id: $_id, razon: $razon)
            }
          }
        `,
        variables: {
          _id,
          razon
        }
      })
      .then(result => result.data.data.Factura.createNotaCreditoBulk),

  readTransactionsByEmisor: (emisor, filter) =>
    api
      .send({
        query: gql`
          query readTransactionsByEmisor($emisor: ID!, $filter: FilterVentas!) {
            Pago {
              readTransactionsByEmisor(emisor: $emisor, filter: $filter) {
                _id
                tipo
                fecha
                concepto
                monto
                estado
              }
            }
          }
        `,
        variables: {
          emisor,
          filter
        }
      })
      .then(result => result.data.data.Pago.readTransactionsByEmisor),

  addAttachment: (_idEmisor, _idFactura, src, name, detail) =>
    api
      .send({
        query: gql`
          mutation addAttachment($_idEmisor: ID!, $_idFactura: ID!, $src: String!, $name: String, $detail: String) {
            Factura {
              addAttachment(_idEmisor: $_idEmisor, _idFactura: $_idFactura, src: $src, name: $name, detail: $detail)
            }
          }
        `,
        variables: {
          _idEmisor,
          _idFactura,
          src,
          name,
          detail
        }
      })
      .then(result => result.data.data.Factura.addAttachment),

  deleteAttachment: (_idFactura, _id, src) =>
    api
      .send({
        query: gql`
          mutation deleteAttachment($_idFactura: ID!, $_id: ID!, $src: String!) {
            Factura {
              deleteAttachment(_idFactura: $_idFactura, _id: $_id, src: $src)
            }
          }
        `,
        variables: {
          _idFactura,
          _id,
          src
        }
      })
      .then(result => result.data.data.Factura.deleteAttachment),

  readAttachments: _idFactura =>
    api
      .send({
        query: gql`
          query readAttachments($_idFactura: ID!) {
            Factura {
              readAttachments(_idFactura: $_idFactura) {
                _id
                src
                name
                detail
              }
            }
          }
        `,
        variables: {
          _idFactura
        }
      })
      .then(result => result.data.data.Factura.readAttachments),

  setCreatedAt: (_idFactura, createdAt) =>
    api
      .send({
        query: gql`
          mutation setCreatedAt($_idFactura: ID!, $createdAt: Date!) {
            Factura {
              setCreatedAt(_idFactura: $_idFactura, createdAt: $createdAt)
            }
          }
        `,
        variables: {
          _idFactura,
          createdAt
        }
      })
      .then(result => result.data.data.Factura.setCreatedAt)
}
